/* SteamZap offer popup — "Unlock 10% off your first order".
   Subscribes the email to a Klaviyo list (client API) so the existing welcome flow sends the code,
   or falls back to Shopify's customer newsletter form. No dependencies. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  function Offer(root) {
    var self = this;
    this.root = root;
    this.cfg = {
      key: 'sz-offer:' + (root.getAttribute('data-storage') || 'default'),
      delay: parseInt(root.getAttribute('data-delay') || '6', 10),
      exitIntent: root.getAttribute('data-exit-intent') !== 'false',
      dismissDays: parseInt(root.getAttribute('data-dismiss-days') || '7', 10),
      companyId: root.getAttribute('data-klaviyo-company') || '',
      listId: root.getAttribute('data-klaviyo-list') || '',
      source: root.getAttribute('data-source') || 'SteamZap site popup',
      code: root.getAttribute('data-code') || '',
      successText: root.getAttribute('data-success') || "You're in. Check your inbox for your code.",
      teaserLabel: root.getAttribute('data-teaser') || 'UNLOCK 10% OFF'
    };
    this.state = store(this.cfg.key) ? JSON.parse(store(this.cfg.key)) : {};
    this.build();
    if (this.state.subscribed) { this.teaser.style.display = 'none'; return; }
    var dismissedAt = this.state.dismissedAt || 0;
    var fresh = (Date.now() - dismissedAt) < this.cfg.dismissDays * 86400000;
    if (!fresh) {
      if (this.cfg.delay >= 0) setTimeout(function () { if (!self.opened) self.open(); }, this.cfg.delay * 1000);
      if (this.cfg.exitIntent) {
        document.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget && e.clientY <= 0 && !self.opened) self.open();
        });
      }
    }
  }

  Offer.prototype.build = function () {
    var self = this, r = this.root;
    this.teaser = el('button', 'sz-offer__teaser');
    this.teaser.type = 'button';
    this.teaser.innerHTML = '<span class="sz-offer__teaser-tag">10%</span><span>' + this.escape(this.cfg.teaserLabel) + '</span>';
    this.teaser.addEventListener('click', function () { self.open(true); });
    r.appendChild(this.teaser);

    this.overlay = el('div', 'sz-offer');
    this.overlay.setAttribute('role', 'dialog');
    this.overlay.setAttribute('aria-modal', 'true');
    this.overlay.setAttribute('aria-label', r.getAttribute('data-headline') || 'Unlock 10% off');
    this.card = $('[data-sz-offer-card]', r);
    this.overlay.appendChild(this.card);
    r.appendChild(this.overlay);

    this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.dismiss(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.overlay.classList.contains('is-open')) self.dismiss(); });
    Array.prototype.forEach.call(r.querySelectorAll('[data-sz-offer-close]'), function (b) { b.addEventListener('click', function () { self.dismiss(); }); });

    this.form = $('form', this.card);
    this.input = $('input[type="email"]', this.card);
    this.button = $('button[type="submit"]', this.card);
    this.error = $('[data-sz-offer-error]', this.card);
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    if (this.cfg.code) {
      var copy = $('[data-sz-offer-copy]', this.card);
      if (copy) copy.addEventListener('click', function () {
        try { navigator.clipboard.writeText(self.cfg.code); copy.textContent = 'COPIED ✓'; } catch (err) { /* noop */ }
      });
    }
  };

  Offer.prototype.escape = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  Offer.prototype.open = function (manual) {
    this.opened = true;
    this.overlay.classList.add('is-open');
    document.documentElement.classList.add('sz-offer-open');
    var self = this;
    setTimeout(function () { if (self.input) self.input.focus({ preventScroll: true }); }, 50);
    if (!manual) this.save({ shownAt: Date.now() });
  };

  Offer.prototype.dismiss = function () {
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('sz-offer-open');
    this.save({ dismissedAt: Date.now() });
  };

  Offer.prototype.save = function (patch) {
    for (var k in patch) this.state[k] = patch[k];
    store(this.cfg.key, JSON.stringify(this.state));
  };

  Offer.prototype.submit = function () {
    var self = this;
    var email = (this.input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { this.error.textContent = 'Enter a valid email address.'; return; }
    this.error.textContent = '';
    this.button.disabled = true;
    var label = this.button.textContent;
    this.button.textContent = '…';
    var p;
    if (this.cfg.companyId && this.cfg.listId) {
      p = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(this.cfg.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { custom_source: this.cfg.source, profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: this.cfg.listId } } }
          }
        })
      }).then(function (r) { if (!(r.status === 202 || r.ok)) throw new Error('Klaviyo ' + r.status); });
    } else {
      var body = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[tags]': 'newsletter, popup-10' });
      p = fetch('/contact', { method: 'POST', body: body, headers: { 'Accept': 'text/html' } }).then(function (r) { if (!r.ok && r.status !== 302) throw new Error('Shopify ' + r.status); });
    }
    p.then(function () {
      try { if (window._learnq) window._learnq.push(['identify', { $email: email }]); } catch (e) { /* noop */ }
      self.save({ subscribed: true, email: email, at: Date.now() });
      self.card.classList.add('is-done');
      var done = $('[data-sz-offer-done]', self.card);
      if (done) done.hidden = false;
      var form = $('[data-sz-offer-form]', self.card);
      if (form) form.hidden = true;
      self.teaser.style.display = 'none';
      document.dispatchEvent(new CustomEvent('sz:offer:subscribed', { detail: { email: email } }));
    }).catch(function (err) {
      self.button.disabled = false;
      self.button.textContent = label;
      self.error.textContent = "That didn't go through. Please try again.";
      if (window.console) console.warn('sz-offer', err);
    });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sz-offer]'), function (root) {
      if (root.__szOffer) return;
      root.__szOffer = new Offer(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.SteamZapOffer = { init: init };
})();
